import { React } from 'imports';
import './Forbidden.less';

export default class Forbidden extends React.PureComponent {
    render() {
        return (
            <div className="forbidden">
                You don't have access to the page{/* TODO https://4straction.atlassian.net/browse/STR-1391 */}
            </div>
        );
    }
}
